// import * as endpoints from './APIEndpoints';
import {appStore} from './AppStore';
import {action, observable} from 'mobx';
import {message,Icon} from 'antd';
import {booleanAsString, toUrlParams} from "./Util";
import {dateColProps} from "../components/AggridHelper";
import cmFormDefs from './formFields/CmLooseDashbordForm';
import editorFormDefs from './formFields/CmLooseDashbordForm';
import pmFormDefs from './formFields/PmLooseleafForm';
import LooseLeafStore from './LooseLeafStore';
import copy from '../images/copy.png'
import moment from "moment";
import { paginationmsgfrmpartner } from "../stores/APIEndpoints";
import newgenlogo from "../../src/images/newgenlogo.png";
import Api from "./APIEndpoints";
import { PageHeader,Button,Badge,Tooltip} from 'antd';
import React, { Component, Fragment } from 'react';

class DashboardMessageFromPartnerStore {
    apiProxy = null;

    constructor() {
        this.apiProxy = appStore.apiProxy;
    }

    @observable activeTab = '0';
    @observable getCountryName = '';

    @observable activeFilter = 'all';
    @observable currentTable = '';
    @observable currentData = {};

    @observable drawerVisible = false;

    @observable rowData = [];
    @observable summaryData = [];

    @observable loading = false;

    @observable selectedApprevation = '';

    @action setLoading = (loading) => {
        this.loading = loading;
    };
    defaultColDef= {
        sortable: true,
        resizable: true,
        filter: true,
      }


      unprocessedColumns = [
        //{headerName: "Fuzzy Id", field:'fuzzy_id'},
        //{headerName: 'FilePath', field: 'file_path'},
        //{headerName: 'Partner Name', field: 'partner_name'},
        {headerName: 'Status', field:'status'},
        //{headerName: 'Partner Type', field: 'partner_type'},
        {headerName: 'Message', field: 'message'},
        {headerName: 'Identifier', field: 'identifier'},
        {headerName: 'Created At', field: 'created_at',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {created_at} = data;
            if (!created_at) return '-';
            return moment(created_at).format('YYYY-MM-DD');
        }
        },
     ];
      processedColumns = [
        //{headerName: "Fuzzy Id", field:'fuzzy_id'},
        //{headerName: 'FilePath', field: 'file_path'},
        //{headerName: 'Partner Name', field: 'partner_name'},
        {headerName: 'Status', field:'status'},
        //{headerName: 'Partner Type', field: 'partner_type'},
        {headerName: 'Message', field: 'message'},
        {headerName: 'Identifier', field: 'identifier'},
        {headerName: 'Created At', field: 'created_at',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {created_at} = data;
            if (!created_at) return '-';
            return moment(created_at).format('YYYY-MM-DD');
        }
        },
     ];
     get columnDefs() {
        if(this.activeFilter=="unprocessed")
        {
            return this.unprocessedColumns;
        }
        else if(this.activeFilter =="all")
        {
            return this.processedColumns;
        }
    }
   
    @action clickCustomFilter = async (filterValue) =>{
        this.activeFilter = filterValue;
        let tempRowData = [];
            for(let i=0; i<this.currentTable.length; i++)
            {
                if(filterValue == 'unprocessed' && this.currentTable[i].stage=='Unprocessedmessagefrompartners')
                {
                    tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'all' && this.currentTable[i].stage=='Processedmessagefrompartners')
                {
                    tempRowData.push(this.currentTable[i]);
                }
            }
            
            this.rowData = tempRowData;
           // this.getSummaryData();
     }
     @action getSummaryData = async()=>{
        this.activeFilter = 'all';
         let totalMonograph =[];
         let flags = [];
         let summaryRows=[];
        for(let i=0; i<this.currentTable.length; i++) {
            if(flags[this.currentTable[i].abbreviation]) continue;
            flags[this.currentTable[i].abbreviation] = true;
            totalMonograph.push(this.currentTable[i].abbreviation);
        }
     
        
        for(let i=0; i<totalMonograph.length; i++)
        {
           let total = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i])});
           let processedMsg = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Processed message from partners")});
           let unprocessedMsg = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Unprocessed message from partners")});
          
           summaryRows.push({
                id:(i),
                rowno:(i+1),
                abbreviation:totalMonograph[i],
                totalMonograph:total.length,
                Processedmessagefrompartners:processedMsg.length,
                Unprocessedmessagefrompartners:unprocessedMsg.length
           })
        }
        this.rowData = summaryRows;
     
    }
    //  @action fetchData = async () => {
    //     this.setLoading(true);
    //     try {
            
    //         const params = {"where":{"partnerName":"publish_one_for_cdb"},"limit":"5"}    
    //         const data = await Api.messagefromparnersDataUrl.get(params);
    //         this.rowData = data;
    //         //this.clickCustomFilter(this.activeFilter);
    //         // this.currentTable = data;
    //         //his.clickCustomFilter('processed');
    //        //  this.rowData = data;
    //     } catch (e) {
    //         message.error('Failed to fetch data');
    //         console.error(e);
    //     }
    //     this.setLoading(false);
    // };
   
    getPageinfo = async (value) => {
        try {
            const params = {
                limit:1000,
                page_no: value
            };
            const url = paginationmsgfrmpartner + '?' +toUrlParams(params);
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();
            this.rowData = data;
        } catch (e) {
        }
    };

       
    getIdentifierinfo = async (value) => {
        try {
            const params = {"where":{"identifierId":value},"limit":"5"}
            const data = await Api.messagefromparneridentifierUrl.get(params);
            this.rowData = data;
        } catch (e) {
        }
    };
    flattenData = async(response) => {
          const rowData = [];
        //   console.log(response);
          Object.keys(response).forEach(publication => {
          const datalist = response[publication];
          datalist.forEach(dt => {
            rowData.push({
              fuzzy_id: dt.fuzzy_id,
              file_path: dt.file_path,
              partner_name: dt.partner_name,
              status: dt.status,
              partner_type: dt.partner_type,
              message: dt.message,
              identifier: dt.identifier,
              created_at: dt.created_at,
            });
          });
        });
 
        return rowData;
      };

    @action setCurrentData = (data) => {
        this.currentData = data;
        this.drawerVisible = true;
    };
    @action setCreateData = visible => {
        this.currentData = '';
        this.drawerVisible = visible;
        this.activeTab = '0';
    };
    @action nextTab = () => {
        if (this.activeTab == "0") {
            this.activeTab = "1";
        } else if (this.activeTab == "1") {
            this.activeTab = "0";
        } else {
            this.drawerVisible = false;
            this.activeTab = "0";
        }
    };
 
}

export default new DashboardMessageFromPartnerStore();